import type { Messages } from "../types";

/** Simplified Chinese — picker language. Written for the member path. */
export const zh_Hans: Messages = {
  common: {
    brand: "UN8",
    brandTag: "专属基督徒相守",
    continue: "继续",
    next: "下一步",
    leave: "离开",
    leaveForNow: "先离开",
    yes: "是",
    no: "否",
    goBack: "返回",
    saving: "正在保存…",
    submitting: "正在提交…",
    pleaseWait: "请稍候…",
    ellipsis: "…",
    male: "男",
    female: "女",
    phases: {
      gate: "门槛",
      verify: "核验",
      setup: "设置",
      profile: "资料",
    },
    storageQuota: "这台手机没有足够空间保存答案。请清理存储后再试。",
    storageDisabled: "此浏览器不会保存你的答案。请关闭隐私模式，或允许网站数据，然后重新加载。",
    charMeta: "{len}/{min} 最少 · {current}/{max}",
    charMetaMin: "最少 {min} 个字符",
  },

  welcome: {
    promise: "我们的目标是让你尽快删除这个应用。",
    sub: "每周四个人。真实面孔。朝向婚姻的相守——然后删除应用。",
    signedInAs: "已登录为 {email}",
    liveServer: " · 线上服务器",
    deviceOnly: " · 仅此设备",
    migrateOffer:
      "此设备仍有一份本地资料。要上传到共享服务器，好让其他手机在审核后看到你吗？在你选择之前不会上传任何内容。",
    uploadLocalProfile: "上传我的本地资料",
    keepOnDevice: "只留在这台设备上",
    migrateNeedGender: "请先在资料里选择男或女。",
    migrateDone: "资料文字已上传。请重新上传证件、视频和照片，以便审核。",
    deleteConfirm: "永久删除你的账户、全部消息和全部媒体（包括证件和视频）？",
    accountDeleted: "账户已删除。",
    begin: "我加入",
    betaTitle: "Welcome UN8 Beta Tester!",
    betaBody:
      "This is the closed web test. Use the app in this browser. Play Billing and TestFlight are not open yet — there is no web checkout.",
    tryMatching: "Open matching",
    reportBug: "Report a bug",
    startFresh: "Start this phone fresh",
    continueOnboarding: "继续设置",
    logIn: "登录",
    logOut: "退出",
    reviewConsole: "审核控制台",
    matching: "配对",
    deleteMyAccount: "删除我的账户",
  },

  intro: {
    title: "欢迎来到 UN8",
    text: "认真的信仰。真实的面孔。朝向婚姻的相守——然后删除应用。",
    videoHint: "放入 public/intro.mp4 即可在此播放短片。",
    continue: "我加入",
    skip: "跳过",
    betaLine: "Welcome UN8 Beta Tester!",
  },

  faith: {
    eyebrow: "首先。",
    title: "你是耶稣的跟随者吗？",
    text: "UN8 是为跟随耶稣基督的人而设。",
    yesTitle: "是",
    yesBody: "",
    noTitle: "否",
    noBody: "",
    respectTitle: "带着尊重",
    respectBody:
      "UN8 只服务一个群体，我们宁愿诚实，也不愿浪费你的时间。若这里不是你的家，请点下方离开或返回。",
    sharedTitle: "共同根基",
    sharedBody: "信仰在这里不是标签。它是你们相遇的土地。",
    hintNotChristian: "UN8 是为跟随耶稣基督的人而设。请点下方离开，或选择基督徒选项（若那是你）。",
    hintUnset: "点“我是基督徒”继续，或离开 / 返回（若这里不是你的家）。",
  },

  rules: {
    eyebrow: "然后是这个。",
    title: "三条规则。没有例外。",
    text: "确认每一条。三条都必须同意。违规将永久移除。虚假资料永远封禁。",
    agreeContinue: "我同意 — 继续",
    respectful: {
      title: "彼此尊重",
      description: "以尊严说话行事。这里每一个人都是按神的形象所造。",
    },
    noSexualContent: {
      title: "禁止色情内容",
      description: "禁止露骨照片、消息或请求。纯洁在这里不是可选项。",
    },
    noDominance: {
      title: "不可支配或控制",
      description: "禁止胁迫、操纵或施压。爱不去控制。",
    },
    hint: "继续前请勾选全部三项承诺。",
  },

  intent: {
    eyebrow: "",
    title: "你在寻找什么？",
    text: "",
    marriage: {
      label: "一生的伴侣",
      description: "",
    },
    discernment: {
      label: "认真分辨",
      description: "",
    },
    notCasual: {
      label: "不是随便聊聊",
      description: "",
    },
    hint: "选一个。",
  },

  account: {
    eyebrow: "账户",
    title: "你的邮箱是？",
    text: "",
    recoveryTitle: "保存你的恢复码",
    recoveryText: "只显示一次。没有它，本次封闭测试中丢失的密码无法重置。",
    savedContinue: "我已保存 — 继续",
    handle: "邮箱",
    handlePlaceholder: "you@example.com",
    passphrase: "密码",
    passphrasePlaceholder: "至少 8 个字符",
    signedInTitle: "已登录",
    signedInBody: "{email} · {userId}",
    trustTitle: "信任标准",
    trustBody: "在身份核验完成且审核通过之前，资料不会对外显示。",
    continueToVerification: "继续核验",
    hintEmail: "请输入包含 @ 的邮箱。",
    hintPassword: "请设置至少 8 个字符的密码。",
  },

  verify: {
    intro: {
      eyebrow: "核验",
      title: "信任就是门槛",
      text: "上传政府证件、确认视频，以及 {min}–{max} 张真实照片。全部进入审核队列后，你的资料才能出现。",
      whyTitle: "我们为何核验",
      whyBody: "钓鱼资料和半真半假在这里没有位置。虚假资料永久封禁。媒体在批准前保持 pending_review。",
      start: "开始核验",
    },
    steps: {
      id: { title: "政府证件", description: "护照或国民身份证 — 拍照或上传文件。" },
      video: { title: "确认视频", description: "一段短录像，证明你本人在场。" },
      photos: { title: "真实照片", description: "四到六张清晰的本人照片。" },
      review: { title: "诚信审核", description: "上传保持 pending_review，直到工作人员确认。" },
    },
    id: {
      eyebrow: "第 1 步，共 4 步",
      title: "政府证件",
      text: "拍摄或上传护照或国民身份证。不会公开张贴 — 状态保持 pending_review，直到工作人员确认。",
      savedTitle: "证件已保存",
      savedBody: "下一步是一段面部确认视频，然后是 {min}–{max} 张本人真实照片。证件显示已保存后即可继续。",
      hint: "拍摄或上传政府证件照片，并等到显示已保存。",
    },
    video: {
      eyebrow: "第 2 步，共 4 步",
      title: "确认视频",
      text: "录一段短片（约 {seconds} 秒）或上传。面向镜头，口齿清楚。这证明你本人在场 — 不是抓取的图库。",
      hint: "录一段确认视频，并等到显示已保存。",
    },
    photos: {
      eyebrow: "第 3 步，共 4 步",
      title: "你最好的一张照片。",
      text: "先有一张就够。",
      continueToReview: "下一步",
      hint: "添加 {min} 到 {max} 张清晰本人照片。保存后即可继续。",
    },
    review: {
      eyebrow: "第 4 步，共 4 步",
      title: "诚信审核",
      text: "媒体以 pending_review 排队{underUser}。配对和喜欢使用同一 id。",
      underUser: "，用户 {userId}",
      governmentId: "政府证件",
      confirmationVideo: "确认视频",
      photos: "照片",
      missing: "缺失",
      filesReady: "{count} 个文件就绪",
      submittedTitle: "已提交审核",
      submittedText: "申请 id 等于登录用户 id，以便批准 → 池与互相喜欢保持一致。",
      submitContinue: "提交并继续",
    },
  },

  setup: {
    eyebrow: "账户设置",
    title: "几个问题。",
    text: "不是普查。说够让一个真人找到你。",
    beginSetup: "开始吧",
    pillars: {
      faith: { name: "信仰", text: "你为何跟随基督。" },
      character: { name: "品格", text: "忠诚、诚实、热情、委身 — 1–10 分。" },
      story: { name: "故事", text: "你是谁，你在寻找什么。" },
      life: { name: "生活", text: "爱好、阅读与职业。" },
    },
    whyChristian: {
      eyebrow: "信仰",
      title: "为何是耶稣？",
      text: "真正的理由。不是主日学那一套。",
      label: "你的回答",
      placeholder: "真正的理由。不是主日学那一套。",
      hint: "一句话就够。",
    },
  },

  scales: {
    eyebrow: "品格量表",
    title: "我们诚实一点！",
    text: "",
    loyalty: { label: "忠诚", hint: "请诚实 — 你对所爱之人有多坚定？" },
    honesty: { label: "诚实", hint: "你有多一贯地说出全部真相？" },
    passion: { label: "热情", hint: "信念与深度 — 不是表演。" },
    commitment: { label: "委身", hint: "你有多准备建造长久之事？" },
    social: { label: "社交", hint: "一端是安静的夜晚。另一端是满屋的人。" },
    creativity: { label: "创造力", hint: "你有多自由地创造与发明？" },
    humor: { label: "幽默", hint: "你有多容易笑 — 也让别人笑？" },
    hint: "请设定每一个数字。",
  },

  about: {
    eyebrow: "关于你",
    title: "你到底是谁？",
    text: "",
    label: "关于你",
    placeholder: "几句话。你会告诉朋友的那种。",
    hint: "一句话就够。",
  },

  looking: {
    eyebrow: "伴侣",
    title: "你在寻找什么？",
    text: "",
    partnerCountry: "希望伴侣所在的国家",
    partnerCountryHint:
      "选择“与我相同”或特定国家会隐藏其他国家的人。对方资料缺国家永远不会拦截（未完成，不是不匹配）。",
    partnerCountrySame: "与我同一国家",
    partnerCountrySameBody: "只显示我所在国家的人。",
    partnerCountryAny: "任何国家",
    partnerCountryAnyBody: "不按国家筛选 — 由契合度决定。",
    partnerCountrySpecific: "特定国家",
    partnerCountrySpecificBody: "只显示我所选国家的人。",
    partnerCountryPick: "国家",
    label: "期望的品格",
    placeholder: "品格。不是购物清单。",
    hint: "一句话就够。",
  },

  loveReady: {
    eyebrow: "门槛",
    title: "准备好遇见一生的爱了吗？",
    text: "",
    yesTitle: "是",
    yesBody: "",
    noTitle: "还没有",
    noBody: "",
    comeBackTitle: "准备好再回来",
    comeBackBody:
      "UN8 是给准备遇见的人 — 不是收藏选项的人。若想先停，点下方离开。答案已保存在这台手机。",
    hintNo: "只有“是”才能继续。若还没准备好，点先离开 — 答案留在这台手机。",
    hintUnset: "若你准备为婚姻遇见某人，请点是。",
  },

  lifestyle: {
    eyebrow: "生活方式",
    title: "你实际在做什么？",
    text: "先玩，再工作。就这些。",
    anythingInteresting: "还有什么有意思的？",
    anythingInterestingPlaceholder: "可选 — 癖好、习惯或生活细节，帮人认识你。",
    anythingInterestingHint: "可选。与“关于你”一起显示。",
    hobbies: "正在做的运动或爱好",
    hobbiesPlaceholder: "你为乐趣做的事。",
    reading: "你读书吗？",
    readingHint: "1 = 几乎不 · 10 = 每天深读",
    profession: "职业 / 行业",
    professionPlaceholder: "你做什么工作。",
    hintHobbies: "说出一件你真正在做的事。",
    hintReading: "滑动“你读书吗？”使 1 到 10 的数字出现。",
    hintProfession: "一个短词就够。",
  },

  faithDepth: {
    eyebrow: "配对 · 信仰",
    title: "信仰在你生命中有多核心？",
    text: "服侍神 — 在你生命中有多重要？请诚实回答。配对用它看深度，不是表演。",
    serving: "服侍神 — 重要程度",
    servingHint: "10% … 100%。以 10 为步进。",
    keepsCommandments: "你遵守诫命吗？",
    grewUpInChurch: "你在教会长大吗？",
    churchAttendance: "聚会频率",
    frequent: { label: "经常", hint: "定期与基督的身体聚集。" },
    seldom: { label: "很少", hint: "偶尔，不是每周节奏。" },
    never: { label: "从不", hint: "目前没有参加。" },
    spreadsGospel: "你传福音吗？",
    hasIdols: "你有偶像吗？",
    hintServing: "滑动服侍神在你生命中的重要程度。",
    hintCommandments: "回答你是否遵守诫命 — 是或否。",
    hintGrewUp: "回答你是否在教会长大 — 是或否。",
    hintAttendance: "选择你参加聚会的频率。",
    hintGospel: "回答你是否分享福音 — 是或否。",
    hintIdols: "回答你是否有偶像 — 是或否。",
  },

  character: {
    eyebrow: "配对 · 品格",
    title: "你在家里是谁",
    text: "相守所需的品格 — 使人和睦、礼貌、诚实。夸大答案只会让以后不匹配。",
    peacemaker: "你是使人和睦的人吗？",
    homebuilder: "你是建立家庭的人吗？",
    humorous: "你幽默吗？",
    caring: "体贴且有爱意？",
    peacefulHome: "你想要一个没有争斗的平安之家吗？",
    manners: "有礼貌吗？",
    honestyRating: "本问卷的诚实评分",
    honestyHint: "1–10 — 你回答得有多诚实？",
    hintPeacemaker: "每一项答是或否，从使人和睦开始。",
    hintHomebuilder: "回答你是否建立家庭。",
    hintHumorous: "回答你是否幽默。",
    hintCaring: "回答你是否体贴有爱。",
    hintPeaceful: "回答你是否想要平安的家。",
    hintManners: "回答你是否有礼貌。",
    hintHonesty: "将诚实评分滑到 1 到 10。",
  },

  history: {
    eyebrow: "配对 · 过往",
    title: "过去与预备",
    text: "物质、童年、伤痕，以及你是否预备进入长久关系。这里的真话保护你们双方。",
    marijuana: "你用过大麻吗？",
    lsd: "你用过 LSD 吗？",
    otherDrugs: "你用过其他毒品吗？",
    addicted: "你曾成瘾吗？",
    childhood: "稳定、被爱的童年？",
    scars: "有伤痕 / 受伤吗？",
    lasting: "预备好进入长久关系了吗？",
    hintStart: "本页每一项答是或否，从上面开始。",
    hintLsd: "回答 LSD 问题 — 是或否。",
    hintOtherDrugs: "回答你是否用过其他毒品。",
    hintAddicted: "回答你是否曾成瘾。",
    hintChildhood: "回答你的童年是否稳定被爱。",
    hintScars: "回答你是否带着伤痕。",
    hintLasting: "回答你是否预备好长久关系。",
  },

  appearance: {
    eyebrow: "配对 · 外貌",
    title: "纹身",
    text: "你自己的纹身，以及你是否接受伴侣有纹身。",
    hasTattoos: "你有纹身吗？",
    acceptsPartner: "接受伴侣有纹身吗？",
    hintHas: "说明你是否有纹身 — 是或否。",
    hintAccepts: "说明伴侣有纹身对你是否可接受。",
  },

  home: {
    eyebrow: "配对 · 家与土地",
    title: "土地、技能、自给",
    text: "草药、种菜、果林、预备、社区农耕、保存、生存 — 以及任何特别技能。",
    herbKnowledge: "草药知识？",
    plantOwn: "你自己种水果蔬菜吗？",
    fruitForest: "对果林感兴趣？",
    prepping: "为灾祸做预备？",
    communityFarming: "社区农耕 / 独立生活？",
    canning: "罐装与保存？",
    survival: "生存技能？",
    specialSkills: "特别技能（可选）",
    specialPlaceholder: "你还能为家庭或土地带来什么…",
    hintStart: "土地与技能每一项答是或否，从上面开始。",
    hintPlant: "回答你是否自己种菜果。",
    hintFruitForest: "回答你是否对果林感兴趣。",
    hintPrepping: "回答你是否为灾祸预备。",
    hintCommunity: "回答你是否对社区农耕感兴趣。",
    hintCanning: "回答你是否罐装保存食物。",
    hintSurvival: "回答你是否有生存技能。",
  },

  family: {
    eyebrow: "配对 · 家庭",
    title: "孩子、信仰深度、物质",
    text: "你对伴侣在信仰强度、孩子和过往物质使用上的需要。",
    children: "孩子",
    wants: { label: "想要孩子", hint: "建立家庭是异象的一部分。" },
    doesNotWant: { label: "不想要孩子", hint: "对孩子明确说不。" },
    open: { label: "开放", hint: "仍在分辨 — 两边都未锁定。" },
    hasLivingWith: { label: "已有孩子 — 与他们同住", hint: "孩子已是日常生活的一部分。" },
    requiredFaith: "你希望伴侣具备的最低信仰程度",
    requiredFaithHint: "10% … 100%。双方都回答后成为硬门槛。",
    acceptsSubstances: "接受伴侣过往的物质使用吗？",
    hintChildren: "选择一张关于孩子的卡片。",
    hintFaith: "滑动你希望伴侣具备的最低信仰程度。",
    hintSubstances: "说明伴侣过往物质使用是否可接受。",
  },

  ancestry: {
    eyebrow: "配对 · 背景",
    title: "背景偏好",
    text: "分享你的背景，以及你对伴侣的开放范围。这只影响排序 — 从不把人从牌组里藏起来。",
    yourBackground: "你的背景（可多选）",
    openToPartner: "对伴侣开放的范围",
    codeDesc: "代码：{code}",
    anyDesc: "最宽的偏好 — 不确定时建议选择。",
    preferenceOnly: "仅偏好 — 不是门槛。",
    hintOwn: "至少勾选一项描述你的背景。这只帮助排序 — 从不隐藏任何人。",
    hintAccepted: "勾选你对伴侣开放的范围，或“开放 — 无偏好”。",
  },

  interests: {
    eyebrow: "配对 · 兴趣",
    title: "你喜欢什么",
    text: "至少选一项。重叠有助于排序；沉默从不被惩罚。",
    hint: "至少勾选一项兴趣。",
  },

  reflection: {
    eyebrow: "配对 · 反思",
    title: "用你自己的话",
    text: "这四项完整展示，从不计分。写下真实的。",
    textThree: "这三项完整展示，从不计分。写下真实的。",
    describeYourself: "描述你自己",
    lifePurpose: "人生目的",
    fifteenYear: "十五年后面你与一生的爱",
    weaknesses: "软弱",
    hintDescribe: "用至少 {min} 个字符描述自己。",
    hintPurpose: "用至少 {min} 个字符写下人生目的。",
    hintVision: "用至少 {min} 个字符写下十五年异象。",
    hintWeaknesses: "用至少 {min} 个字符写下一项软弱。",
  },

  profile: {
    eyebrow: "资料",
    title: "你的信息是什么？",
    text: "你的真名。UN8 只有经过核验的人。",
    firstName: "名",
    firstNamePlaceholder: "你的真名",
    age: "年龄",
    agePlaceholder: "18+",
    country: "国家",
    countryPlaceholder: "选择你的国家",
    geoDetected: "根据连接检测到：{country}。你可以更改。",
    geoUnavailable: "无法检测国家 — 请选择你的。",
    city: "城市",
    cityPlaceholder: "你所在的城市",
    sex: "性别",
    maleBody: "我是男人。",
    femaleBody: "我是女人。",
    hintName: "请输入你的名（至少两个字母）。",
    hintAge: "年龄必须年满 18。",
    hintCity: "请输入你居住的城市。",
    hintGender: "选择男或女，配对才能进行。",
  },

  ready: {
    title: "你进来了。",
    textNamed: "{name}，去找到他们 — 然后删除应用。",
    text: "去找到他们 — 然后删除应用。",
    summaryAria: "设置摘要",
    christianRules: "基督徒 · 已确认规则",
    mediaLine: "证件 · 视频 · {photoCount} 张照片 · 队列 {pending}",
    scalesLine: "量表 忠{loyalty}/诚{honesty}/热{passion}/委{commitment}",
    genderProfession: "{gender} · {profession}",
    sexUnset: "性别 —",
    professionFallback: "职业",
    userLine: "用户 {userId}",
    enterMatching: "看你的四位",
    needGender: "返回资料步骤选择男或女，然后再试。",
  },

  match: {
    brandTag: "配对",
    navOnboarding: "设置",
    navReview: "审核",
    navMatching: "配对",
    navSelection: "本周人选",
    navMessages: "消息",
    navWhoLiked: "赞过你",
    navProfile: "资料",
    logOut: "退出",
    enterTitle: "进入配对",
    enterText: "用设置时的同一邮箱登录。申请、人选池、喜欢与配对都使用你的稳定用户 id。",
    email: "邮箱",
    emailPlaceholder: "you@example.com",
    password: "密码",
    passwordPlaceholder: "你的密码",
    logIn: "登录",
    quietSignIn: "登录",
    guestOr: "或试用演示牌组（异性四位 · 无需再选性别）",
    guestDemo: "继续演示",
    guestMan: "以男士访客进入",
    guestWoman: "以女士访客进入",
    needGender: "请先在设置（资料步骤）选择男或女 — 配对用它做异性配对。",
    goOnboarding: "前往设置 →",
    guestSession: "演示会话 · 演示池",
    bootDemo: "正在打开你本周的四位…",
    signInHint: "已经是成员？",
    closeSignIn: "关闭",
    man: "男士",
    woman: "女士",
    tabToday: "本周人选",
    tabMatches: "消息（{count}）",
    weeklyTitle: "本周你的 4 位",
    weeklyTitleCount: "本周你的 {count} 位",
    weeklyCountdown: "{days} 天后下次人选",
    weeklyCountdownOne: "1 天后下次人选",
    weeklyCountdownSoon: "人选即将到来",
    shortWeekCopy: "本周有 {count} 位。我们从不推荐不合适的人。",
    shortWeekTwo: "本周有两位。我们从不推荐不合适的人。",
    weekDone: "本周人选到此结束",
    weekDoneText: "你已认真看过我们能诚实推荐的每一位。下次人选开放时再来。",
    extraReveal: "再显示一位",
    extraRevealLeft: "还剩 {count} 次额外显示",
    whoLikedTitle: "谁喜欢了你",
    whoLikedHint:
      "Like them back and you match. Then chat is more than thirty-three letters.",
    whoLikedLocked: "订阅后可在本周牌组看到名字 — 收到的心仍显示在消息里。",
    whoLikedEmpty: "还没有新的人喜欢你。",
    inboundTitle: "喜欢了你",
    likeBack: "回心",
    likeHeart: "送出喜欢",
    flame: "送出火焰",
    flameNoneLeft: "本周没有火焰了。周一回来。",
    flameLead: "给 {name} 送出火焰。",
    flameOnly: "只发火焰",
    flameSend: "发送火焰",
    heartBurstTitle: "送给 {name} 的喜欢",
    flameBurstTitle: "给 {name} 的火焰",
    flameSent: "你向 {name} 发送了火焰。",
    flipNeedsLike: "先送出喜欢，才能翻开卡片。",
    likedStays: "A like stays. You cannot take it back.",
    composeCancel: "取消",
    hudAria: "积分、心与火焰",
    menuOpen: "打开菜单",
    menuClose: "关闭",
    refreshTitle: "新的四位",
    heartsNoneLeft: "本周没有心了。你的心周一回来。",
    commentLead: "给 {name} 送出喜欢。",
    commentPlaceholder: "最多 33 个字母",
    commentCount: "{count} / {max}",
    commentSend: "发送喜欢",
    heartOnly: "只发心",
    commentTooLong: "超过 {max} 个字母。心已送出；字条没有。",
    commentAnchors: {
      about: "关于",
      lookingFor: "寻找",
      hobbies: "兴趣",
      photo: "照片",
    },
    profileTitle: "你的资料",
    profileSub: "账户、订阅与测试工具。",
    verify: {
      brandTag: "核验",
      title: "核验后才能发消息",
      sub: "任何人都可以浏览并送心。对话需要你的证件和一段确认视频。已提交即可 — 审核可以再等。",
      cta: "添加证件和视频",
      videoCta: "添加确认视频",
      submitted: "证件和视频已提交。审核期间你可以发消息。",
      done: "你已通过核验。",
      back: "返回",
      continue: "继续",
      idEyebrow: "身份",
      videoEyebrow: "在场",
      idText: "护照或国民身份证。不会公开张贴。已提交即可开始交谈。",
      videoText: "一段短片（约 {seconds} 秒）。面向镜头。这证明你本人在场。",
    },
    yourMatches: "你的消息",
    matchesSub: "持续的互相喜欢 · {count} 次发出的{likesWord}",
    like: "喜欢",
    likes: "喜欢",
    emptyMatches: "还没有互相喜欢。继续分辨本周人选。",
    valuesScore: "价值观 {score}",
    chatOpen: " · 聊天已开",
    tapToChat: " · 点按聊天",
    personLine: "{name}，{age}",
    cityValues: "{city} · 价值观 {score}",
    noProfileYet: "还没有资料",
    noProfileText: "先完成设置，或打开资料再点开始。若只想看看，入口页有访客配对。",
    matchingPaused: "配对已暂停",
    waitingModeration: "你的资料正在等待审核，牌组随后开放。",
    completeProfileFirst: "请先完成并提交资料。",
    moderationDemoNote: "正在显示演示人物，便于你在等待时试用配对。",
    noOneYet: "暂时无人可显示",
    todaysSetDone: "本周人选到此结束",
    emptyNeverHad: "本周名单里还没有人。我们仍在填充池子 — 稍后再打开人选，或等更多成员通过审核。",
    emptyDone: "你已看完本周人选。下次投放开放时再来，或重置牌组再看一次。",
    likesMayNotStick: " 喜欢可能不会保留。",
    poolMeta: "池：{pool} · 配对：{matches} · 已喜欢：{liked}",
    demoPool: "演示",
    livePool: "{source}（{count}）",
    resetDeck: "重置牌组",
    swapFour: "新的四位 · 10 000 积分",
    memberNew: "Just joined",
    memberDays: "{days}d here",
    memberWeeks: "{weeks}w here",
    memberMonths: "{months}mo here",
    cardStatLoyalty: "忠",
    cardStatHonesty: "诚",
    cardStatPassion: "热",
    cardStatCommit: "委",
    cardStatSocial: "社",
    cardStatFaith: "信",
    cardStatCharacter: "品",
    cardStatPurpose: "志",
    cardStatHome: "家",
    cardStatAncestry: "源",
    cardStatTemper: "性",
    goToProfile: "查看资料",
    goToProfileChat: "资料与聊天",
    holdToPeek: "按住{name}的卡片查看数据",
    holdOrOpenProfile: "按住查看数据，点按打开{name}的资料",
    likeToOpenProfile: "喜欢后可打开完整资料",
    waitLikeBack: "等待{name}回心 — 然后可聊天。",
    flipToStats: "查看{name}的资料摘要",
    flipToPhoto: "查看{name}的照片",
    likeToFlip: "按住查看数据。喜欢后打开完整资料。",
    swapNoCredits: "积分不足，无法刷新。免费更换与每位订阅者刷新均为 10 000。",
    likeSent: "已喜欢 {name}。我们会告知对方 — 若对方也喜欢你，即为配对。",
    packTitle: "你的四位",
    packSkip: "点按继续",
    newSelection: "新的人选",
    backToFour: "← 回到你的四位",
    backOnboarding: "返回设置",
    feedEyebrowDemo: "本周人选 · 演示池",
    feedEyebrowLive: "本周人选 · 池（{source}，{count}）",
    feedTitle: "谨慎分辨",
    left: "还剩 {count}",
    pass: "跳过",
    interested: "♥ 喜欢",
    swipeHint: "跳过会在 24 小时内由另一位合适的人替换。我们从不用不合适的人凑数。",
    celebrationEyebrow: "互相喜欢",
    celebrationTitle: "配对成功",
    celebrationText: "{self} · {other}",
    celebrationWhyLabel: "你们为何配对",
    celebrationNote: "",
    celebrationFusing: "成为一条路…",
    celebrationReady: "",
    openChat: "打开聊天",
    keepDiscerning: "继续分辨",
    cardSeeking: "寻找",
    cardHobbies: "爱好",
    matchingScore: "匹配分数",
    affinity: "匹配分数",
    valuesScoreLabel: "匹配分数",
    scoreStrong: "高度契合",
    scoreSolid: "稳固契合",
    scoreModerate: "中等契合",
    scoreDifferent: "节奏不同",
    characterAxisFoot: "品格轴包含四根柱石",
    youThem: "你 {self} · 对方 {other}",
    stampInterest: "心意",
    stampPass: "跳过",
    explainLikedYou: "对方已经喜欢你 — 互相喜欢正在发生。",
    explainLegacyClose: "你们的价值观分数接近（{score} / 100）。",
    explainLegacyFuller: "双方完成配对问题后，会出现更完整的“为什么”。",
    explainFaith: "你们的信仰强度接近 — 跟随耶稣的认真程度相似。",
    explainCharacter: "你们在家里对待人的方式一致 — 和睦、礼貌与关怀。",
    explainPurpose: "你们对自己诚实程度的评分相近，说明态度认真。",
    explainHome: "你们都对土地、种植或自给的家感兴趣。",
    explainAncestry: "你们都偏好相似的家庭背景。这是偏好，不是筛选 — 不会因此隐藏任何人。",
    explainTemperament: "你们的兴趣与性情有重叠。",
    explainFallback: "根据双方已填写的答案，存在可能的配对。",
    explainOverall: "匹配分数 {score}/100",
    scoreBadge: "匹配分数 {score}/100",
    overlapAgree: "我们一致的是",
    overlapDisagree: "我们看法不同的是",
    overlapItems: {
      keepsCommandments: "遵守神的诫命",
      spreadsGospel: "传扬福音",
      grewUpInChurch: "在教会长大",
      peacemaker: "在家使人和睦",
      homebuilder: "建立平安的家",
      caringAffectionate: "表达关怀与爱意",
      wantsPeacefulHome: "渴望平安的家庭",
      goodManners: "礼貌与尊重",
      humorous: "日常生活中的幽默",
      herbKnowledge: "认识草药与自然疗法",
      plantsOwnFruitVeg: "自己种食物",
      interestedInFruitForest: "食物森林与土地",
      preppingForCalamities: "为艰难日子预备",
      communityFarming: "社区农耕与自给",
      canningAndPreserving: "罐装与保存食物",
      survivalSkills: "实用生存技能",
      readyForRelationship: "预备进入长久关系",
      stableChildhood: "稳定、被爱的童年",
      sharedInterests: "{count} 项共同兴趣",
      faithIntensity: "对信仰同样认真",
    },
    affinityAxes: {
      faith: "信仰强度",
      character: "品格与举止",
      purpose: "人生目的契合",
      home: "家与自给",
      ancestry: "文化与背景亲近",
      temperament: "性情契合",
    },
    scaleAxes: {
      loyalty: "忠诚",
      honesty: "诚实",
      passion: "热情",
      commitment: "委身",
    },
  },

  chat: {
    brandTag: "聊天",
    unavailableTitle: "无法聊天",
    unavailableText: "此配对缺失，或不属于你的会话。",
    backToMatches: "返回配对",
    backMatches: "← 配对",
    valuesSubscriber: "价值观 {score} · 订阅者",
    valuesTrial: "价值观 {score} · 试用",
    valuesKept: "价值观 {score} · 配对保留",
    empty: "小心问好。在共享后端上，互相配对后消息会同步到双方手机。",
    placeholder: "给 {name} 发消息…",
    ariaMessage: "消息",
    send: "发送",
  },

  billing: {
    paywallCopy:
      "免费：每周 4 人（更换需 10 000 积分）。订阅 $4.99：每周 5 次刷新 · VIP $9.99：不限。每周可新开一段对话。已有配对永远免费聊天。账单仅限 Google Play。",
    signInToMatch: "登录后才能使用配对。",
    signInFirst: "请先登录。",
    subscriberUntil: "订阅者 · 至 {date}",
    vipUntil: "VIP 俱乐部 · 至 {date}",
    freePlan: "免费 · 每周四位 + 积分",
    renewal: "续订",
    freeTrial: "免费试用 · {days} 天（结束于 {date}）",
    soon: "即将",
    trialEnded: "试用已结束 · 每周四位 + 配对与聊天保留",
    freeTrialEnded: "试用已结束 · 每周四位 + 配对与聊天保留",
    creditsBalance: "{count} 积分",
    creditsUnlimited: "无限积分",
    switchHint: " · 每周更换 {cost}",
    subscribe: "订阅 · ${price}/月",
    subscribeEarly: "提前订阅 · ${price}/月",
    activeNote: "订阅已生效 — 谁喜欢了你与额外显示已解锁。",
    playOnly: "订阅仅限 Google Play Billing（应用安装）。这里没有网页结账。",
    playOnlyShort: "仅通过 Google Play 计费 — 无网页付款。",
    playSubscribeMember: "订阅 · 会员 $4.99/月（Google Play）",
    playSubscribeVip: "加入 VIP · $9.99/月（Google Play）",
    playRestore: "恢复 Google Play 购买",
    playUnavailable: "Google Play Billing 在已安装的应用（TWA）内打开。这里没有网页结账。",
    playBusy: "正在打开 Google Play…",
    playError: "无法完成 Play 购买。请从应用内重试。",
    activateSubscriberQa: "QA：激活订阅者（本地）",
    activateVipQa: "QA：激活 VIP（本地）",
    enablePush: "通知我喜欢与配对",
    pushEnabled: "已开启喜欢与配对通知",
    pushBlocked: "浏览器设置中已拦截通知",
    pushUnavailable: "推送需要 Masco 的 VAPID 密钥 — 应用内喜欢仍然有效。",
  },

  auth: {
    recoveryTitle: "保存你的恢复码",
    recoveryText: "现在写下来。只显示一次。若丢失密码，此码是封闭测试中重置的唯一方式。",
    savedContinue: "我已保存 — 继续",
    welcomeBack: "欢迎回来",
    createAccount: "创建账户",
    intro: "标识与口令。不发送邮件或短信。你的 id 在设置、审核与配对中保持稳定。",
    tabLogin: "登录",
    tabRegister: "注册",
    handle: "标识",
    handlePlaceholder: "you@example.com 或短标识",
    passphrase: "口令",
    passphrasePlaceholder: "至少 8 个字符",
    submitLogin: "登录",
    submitRegister: "创建账户",
    backWelcome: "返回欢迎页",
  },

  options: {
    origin: {
      african: "非洲",
      european: "欧洲",
      asian: "亚洲",
      latino: "拉丁 / 西语裔",
      middleEastern: "中东",
      indigenous: "原住民",
      mixed: "混合",
      other: "其他",
      dutch: "荷兰",
      german: "德国",
      any: "开放 — 无偏好",
    },
    interest: {
      prayer: "祷告",
      worship: "敬拜",
      reading: "阅读",
      hiking: "徒步",
      music: "音乐",
      cooking: "烹饪",
      farming: "农耕 / 园艺",
      sports: "运动",
      missions: "宣教",
      family: "家庭生活",
      crafts: "手作",
      outdoors: "户外",
    },
  },

  capture: {
    yesNoDefaults: { yes: "是", no: "否" },
    id: {
      titleEmpty: "政府证件",
      titleReady: "证件就绪",
      hintEmpty: "护照或国民身份证。现场拍照，或选择图片/PDF。四角都要可见。",
      hintReady: "{fileName} · {bytes}{saved}",
      savedSuffix: " · 已保存",
      previewAlt: "政府证件预览",
      pdfAria: "已选择 PDF 文件",
      takePhoto: "拍照",
      retake: "重拍",
      chooseFile: "选择文件",
      replaceFile: "更换文件",
      remove: "移除",
      uploading: "正在上传…",
      cameraTitle: "拍摄你的证件",
      signIn: "上传证件前请先登录。",
      uploadFailed: "上传失败。请重试。",
      badFile: "无法使用此文件。",
    },
    video: {
      titleEmpty: "确认视频",
      titleLive: "摄像头已开启",
      titleReady: "视频就绪",
      hintEmpty: "说出你的名，并说明你诚实加入 UN8。5–15 秒。",
      hintReady: "{fileName} · {bytes}{saved}",
      rec: "REC {seconds}s",
      record: "录制",
      cameraUpload: "摄像头上传",
      chooseFile: "选择文件",
      startRecording: "开始录制",
      cancel: "取消",
      stopSave: "停止并保存",
      recordAgain: "重新录制",
      replaceFile: "更换文件",
      remove: "移除",
      unsupported: "此处无法现场录制。请用摄像头上传或选择文件。",
      permissionDenied: "摄像头权限被拒绝。你仍可上传短视频文件。",
      signIn: "上传视频前请先登录。",
      uploadFailed: "上传失败。请重试。",
      saveFailed: "无法保存录像。",
      badVideo: "无法使用此视频。",
    },
    photos: {
      count: "{count} / {max} 张照片",
      minimumMet: "已达最低数量",
      moreRequired: "还需 {n} 张",
      listAria: "核验照片",
      photoAlt: "照片 {n}",
      removeAria: "移除照片 {n}",
      camera: "摄像头",
      takePhoto: "拍照",
      chooseFiles: "选择文件",
      uploading: "正在上传…",
      hint: "拍照会打开实时摄像头。选择文件仅用于相册。面部清晰 — 不要用掩盖身份的滤镜。最多 {max} 张。",
      cameraTitle: "给自己拍一张",
      signIn: "上传照片前请先登录。",
      someFailed: "部分照片上传失败。请重试失败的。",
      addFailed: "无法添加照片。",
    },
    liveStill: {
      titleDefault: "摄像头",
      close: "关闭",
      capture: "拍摄",
      cancel: "取消",
      hint: "保持稳定。实时摄像头会一直开着，直到你拍摄。",
      unavailable: "此浏览器没有摄像头。请改用选择文件。",
      permissionDenied: "摄像头权限被拒绝或不可用。请改用选择文件。",
      frameFailed: "无法拍摄这一帧。",
      saveFailed: "无法保存照片。",
    },
    uploadStatus: {
      uploading: "正在上传…",
      failed: "上传失败",
      savedLocally: "已保存在本地",
      uploaded: "已上传",
      stored: "已存储",
      awaitingUpload: "等待上传",
      localFallbackNote: "{error} 文件已保存在此设备；签名接口恢复后再试。",
    },
  },
  language: {
    label: "语言",
    choose: "选择语言",
  },
  shell: {
    back: "返回",
    goBackAria: "返回",
  },
  voiceAssistant: {
    title: "UN8 语音向导",
    fabAria: "打开语音助手",
    panelAria: "语音助手控制",
    start: "开始",
    startAria: "开始语音对话",
    starting: "正在开始…",
    stop: "停止",
    stopAria: "停止语音对话",
    close: "关闭",
    closeAria: "关闭语音助手面板",
    mute: "静音",
    muteAria: "静音助手音频",
    unmute: "取消静音",
    unmuteAria: "取消助手音频静音",
    statusIdle: "点开始，与 UN8 向导交谈。",
    statusConnecting: "正在连接…",
    statusListening: "正在听 — 准备好就说。",
    statusSpeaking: "正在说…",
    statusError: "连接错误。",
    unavailableNotConfigured: "语音助手不可用 — 尚未配置。",
    micDenied: "麦克风权限被拒绝。请在浏览器设置中允许麦克风，然后重试。",
    errorGeneric: "语音助手无法连接。请稍后再试。",
  },

  questionnaire: {
    skipForNow: "暂时跳过",
    skipConsequence: "已回答的资料会优先显示。",
    confirm: "继续",
    progressLabel: "第 {current} / {total}",
    fewSentences: "几句话",
    ancestryNote: "这是偏好，只影响排序 — 从不把人从牌组里藏起来。",
  },
};
